(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sorelane-v63-produit"] && !Shopify.designMode) return;
  try {
    
(function () {
  const initStock = (container) => {
    const roots = container.querySelectorAll('[data-s63-product]');
    roots.forEach((root) => {
      const source = root.querySelector('[data-s63-inventory-states]');
      const status = root.querySelector('[data-s63-inventory-status]');
      const select = root.querySelector('select[name="id"]');
      if (!source || !status || !select || root.dataset.s63StockReady) return;
      let inventory;
      try { inventory = JSON.parse(source.textContent); } catch { return; }
      const label = status.querySelector('[data-s63-inventory-label]');
      if (!label) return;
      const updateStock = () => {
        const state = inventory.states[select.value] || 'unavailable';
        status.dataset.state = state;
        label.textContent = inventory.labels[state];
      };
      root.dataset.s63StockReady = 'true';
      select.addEventListener('change', updateStock);
      updateStock();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStock(document), {once:true});
  } else { initStock(document); }
  document.addEventListener('shopify:section:load', (event) => initStock(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
